import { Dispatch } from "redux";
import {
  ERROR_LOADING_ADMIN_TRACKING,
  GET_ALL_ADMIN_TRACKING,
  RESET_DATA,
  START_LOADING_ADMIN_TRACKING,
  STOP_LOADING_ADMIN_TRACKING,
} from "./action-types";
import apiLibrary from "services/api";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";
import { Toasts } from "view/components/Toasts";

export const fetchAdminTrackingAction =
  () => async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: START_LOADING_ADMIN_TRACKING });

    try {
      const currentState = getState();
      
      const queryString = generateQueryStringForUsers(
        currentState.Filters.adminTrackingFilter
      );

      const { data } =
        await apiLibrary.adminTracking.getAdminTracking(queryString);
      dispatch({
        type: GET_ALL_ADMIN_TRACKING,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({
        type: RESET_DATA,
      });
      console.log("An error occurred while fetching the user profile:", error);
      dispatch({ type: ERROR_LOADING_ADMIN_TRACKING });
      // dispatch(fetchError(error))
    } finally {
      dispatch({ type: STOP_LOADING_ADMIN_TRACKING });
      // dispatch(loadingState(false))
    }
  };
